import { HEALTH_OFFLINE_FAILURE_THRESHOLD } from "@/lib/query-constants";

export type ConnectivityStatus = "online" | "offline";

export interface ConfirmedOfflineState {
  consecutiveFailures: number;
  status: ConnectivityStatus;
}

export function createConfirmedOfflineState(): ConfirmedOfflineState {
  return { consecutiveFailures: 0, status: "online" };
}

/** Apply one settled health-poll cycle outcome to confirmed-offline state. */
export function applyHealthPollCycle(
  state: ConfirmedOfflineState,
  outcome: "success" | "failure",
  threshold: number = HEALTH_OFFLINE_FAILURE_THRESHOLD,
): ConfirmedOfflineState {
  if (outcome === "success") {
    return createConfirmedOfflineState();
  }

  const consecutiveFailures = state.consecutiveFailures + 1;
  return {
    consecutiveFailures,
    status: consecutiveFailures >= threshold ? "offline" : "online",
  };
}
